import { cn } from '@/lib/utils';
import {
  isWebReadyTenant,
  WEBREADY_EXTERNAL_LINKS,
  WEBREADY_LITIGII_IMAGES,
} from '@/lib/webreadyLegal';
import { useTranslation } from 'react-i18next';

interface WebReadyLegalFooterProps {
  linkClass: string;
}

const badgeLinkClass =
  'inline-flex items-center justify-center min-h-[44px] [touch-action:manipulation]';

const badgeFrameClass =
  'flex h-14 items-center justify-center overflow-hidden rounded-[8px] transition-opacity hover:opacity-90';

const badgeImgClass = 'h-full w-auto max-w-[240px] object-contain';

/** ANPC + Consumer Redress EU — legal page links live inline with copyright in Footer.tsx */
export default function WebReadyLegalFooter({ linkClass }: WebReadyLegalFooterProps) {
  const { t } = useTranslation();

  if (!isWebReadyTenant()) {
    return null;
  }

  return (
    <div className="flex w-full flex-wrap items-center justify-center gap-4 md:gap-6 pb-4 md:pb-6">
      <a
        href={WEBREADY_EXTERNAL_LINKS.anpc}
        target="_blank"
        rel="noopener noreferrer"
        className={cn(badgeLinkClass, linkClass)}
        aria-label={t('public.footer.legal.anpc', 'Autoritatea Națională pentru Protecția Consumatorilor')}
        title={t('public.footer.legal.anpc', 'Autoritatea Națională pentru Protecția Consumatorilor')}
      >
        <span className={badgeFrameClass} style={{ width: '150px', height: '42px' }}>
          <img
            src={WEBREADY_LITIGII_IMAGES.anpc}
            alt={t('public.footer.legal.anpc', 'ANPC')}
            className="h-full w-full object-contain"
            loading="lazy"
            decoding="async"
            width={250}
            height={70}
          />
        </span>
      </a>
      <a
        href={WEBREADY_EXTERNAL_LINKS.consumerRedress}
        target="_blank"
        rel="noopener noreferrer"
        className={cn(badgeLinkClass, linkClass)}
        aria-label={t(
          'public.footer.legal.consumerRedress',
          'Soluționarea online a litigiilor — Consumer Redress in the EU'
        )}
        title={t(
          'public.footer.legal.consumerRedress',
          'Soluționarea online a litigiilor — Consumer Redress in the EU'
        )}
      >
        <span className={badgeFrameClass} style={{ width: '156px', height: '42px' }}>
          <img
            src={WEBREADY_LITIGII_IMAGES.sol}
            alt={t('public.footer.legal.solShort', 'SOL')}
            className="h-full w-full object-contain"
            loading="lazy"
            decoding="async"
            width={250}
            height={68}
          />
        </span>
      </a>
    </div>
  );
}
